import * as styles from './AuthFormWrapper.module.css'

function AuthFormWrapper({ children, className = styles.AuthFormWrapper }) {
  return <div className={className}>{children}</div>
}

export default AuthFormWrapper
